import { Fetcher } from '@this/src/util';
import React, { useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import useApi from '@this/shared/hooks/use_api';
import SimpleLoading from '@this/shared/simple_loading/simple_loading';
import SuppliedItemMappingTabs from '@this/components/admin/supplied_item_mappings/share/supplied_item_mapping_tabs';
import { Title } from '../admin';
import { AdminContentIn } from '../shared/atom';

interface Response {
  categories: {
    id: number;
    target_type: string;
    airline_company_type: string;
    display_condition_supplied_item_id: number;
    supplied_item_id: number;
    target_type_value: number;
    airline_company_type_value: number;
  }[];
  supplied_items: {
    id: number;
    supplier_name: string;
    name: string;
  }[];
}

interface SuppliedItem {
  id: number;
  supplierName: string;
  name: string;
}

const IndividualTargetSuppliedItems = () => {
  const styles = useMemo(() => getStyles(), []);
  const [savingTargetType, setSavingTargetType] = useState(0);
  const [savingAirlineCompanyType, setSavingAirlineCompanyType] = useState(0);
  const [reloadFlag, setReloadFlag] = useState(0);
  const params = { reloadFlag };
  const { data, isLoading } = useApi<Response>('/admin/individual_target_supplied_items.json', params);
  const categories = data ? data.categories : [];
  const suppliedItems: SuppliedItem[] = data
    ? data.supplied_items.map(item => ({ id: item.id, supplierName: item.supplier_name, name: item.name }))
    : [];
  const saveMapping = useCallback(
    (
      id: number,
      targetType: number,
      airLineCompanyType: number,
      suppliedItemId: number,
      displayConditionSuppliedItemId: number
    ) => {
      setSavingTargetType(targetType);
      setSavingAirlineCompanyType(airLineCompanyType);
      const saveParams = {
        target_type: targetType,
        airline_company_type: airLineCompanyType,
        supplied_item_id: suppliedItemId,
        display_condition_supplied_item_id: displayConditionSuppliedItemId
      };
      Fetcher.put(`/admin/individual_target_supplied_items/${id}.json`, saveParams)
        .catch(e => {
          alert(
            utils.dig(e, 'responseJSON', 'message') ||
              '通信環境が不安定です。\n時間をおいてもう一度お試しください。'
          );
        })
        .finally(() => {
          setSavingTargetType(0);
          setSavingAirlineCompanyType(0);
          setReloadFlag(reloadFlag + 1);
        });
    },
    [reloadFlag]
  );
  return (
    <div>
      <Title>仕入商品マッピング</Title>
      <AdminContentIn>
        <div style={styles.description}>個別にデフォルトの仕入商品を設定できます。</div>
        <SuppliedItemMappingTabs />
        {isLoading ? (
          <SimpleLoading />
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>対象</th>
                <th style={styles.th}>航空会社</th>
                <th style={styles.th}>表示条件</th>
                <th style={styles.th}>仕入商品</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category, i) => (
                <tr key={i}>
                  <td style={styles.td}>{category.target_type}</td>
                  <td style={styles.td}>{category.airline_company_type}</td>
                  <td style={styles.td}>
                    {savingTargetType === category.target_type_value &&
                    savingAirlineCompanyType === category.airline_company_type_value ? (
                      <SimpleLoading size={18} />
                    ) : (
                      <select
                        style={styles.select}
                        value={category.display_condition_supplied_item_id || ''}
                        onChange={e =>
                          saveMapping(
                            category.id,
                            category.target_type_value,
                            category.airline_company_type_value,
                            category.supplied_item_id,
                            parseInt(e.target.value, 10)
                          )
                        }
                      >
                        {suppliedItems.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.supplierName}：{item.name}
                          </option>
                        ))}
                      </select>
                    )}
                  </td>
                  <td style={styles.td}>
                    {savingTargetType === category.target_type_value &&
                    savingAirlineCompanyType === category.airline_company_type_value ? (
                      <SimpleLoading size={18} />
                    ) : (
                      <select
                        style={styles.select}
                        value={category.supplied_item_id || ''}
                        onChange={e =>
                          saveMapping(
                            category.id,
                            category.target_type_value,
                            category.airline_company_type_value,
                            parseInt(e.target.value, 10),
                            category.display_condition_supplied_item_id
                          )
                        }
                      >
                        {suppliedItems.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.supplierName}：{item.name}
                          </option>
                        ))}
                      </select>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}{' '}
      </AdminContentIn>
    </div>
  );
};

const getStyles = () => ({
  description: {
    marginBottom: 40
  },
  table: {
    margin: 0,
    fontSize: 12,
    width: 'auto' as const
  },
  th: {
    padding: 8
  },
  td: {
    padding: 8
  },
  select: {
    margin: 0
  }
});

export default IndividualTargetSuppliedItems;
